import { FC, useContext, useRef } from "react";

import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useStyles from "../Styles/PopOverStyles";
import metamask from "../../assets/images/metamaskIcon.svg";
import copy from "../../assets/images/copy.svg";
import logoutImg from "../../assets/images/logoutProject.svg";
import { PopoverProps } from "../../interfaces";
import AlertContext from "../../store/Alert/AlertContext";
import { ChainName } from "../../store/Wallet/WalletFunction";
import { useAccount, useConfig, useDisconnect } from "wagmi";
import { useWeb3 } from "../../services/web3/hooks/useWeb3";
import { formatDecimalNumber } from "../../utils/web3/formatBalance";

const ProjectPopover: FC<PopoverProps> = ({
  id,
  open,
  anchorEl,
  handleClose,
  setAnchorEl,
}) => {
  const classes = useStyles();
  const text = useRef<any>();
  const { chain, connector, balance } = useWeb3();
  const config = useConfig();
  const { disconnect } = useDisconnect({ config });
  const { address: account } = useAccount();

  const { setAlert } = useContext<any>(AlertContext);
  const handleDisconnect = (event: any) => {
    event.preventDefault();
    disconnect();
    setAlert("Wallet is disconnected", "success");
    setAnchorEl(null);
  };

  const copytext = async (event: any) => {
    event.preventDefault();
    navigator.clipboard.writeText(text.current.value);
    setAlert("Address Copied!!", "success");
  };

  return (
    <>
      <Popover
        className={classes.popoverpages}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        style={{marginTop:"-.75rem"}}
      >
        <Box  width="18.5" className="popover-box">


        <Box display="flex" 
             width={"calc(100% - 2.5rem)"} 
             justifyContent="space-between"
             alignItems={"center"}
             padding="1.25rem"
            >
          <Box display="flex" alignItems={"center"}>
              <img
                src={metamask}
                alt="metamask"
                className="img-fluid"
                
              />    
                <Typography
                  color="secondary"
                  variant="subtitle1"
                  component="span"
                  style={{marginLeft:"0.5rem"}}
                >
               {account?.substr(0, 6) +
                              "..." +
                account?.substr(account?.length - 6, account?.length)}
                </Typography>  
                <input
                  className="hiddeninput"
                  onChange={(e) => e.preventDefault}
                  value={account!}
                  ref={text}
                />
          </Box>  
            <Box display="flex" alignItems={"center"}>  
                 <Box pr=".5rem" mr=".5rem" borderRight={"1px solid rgba(17, 48, 45, 0.08)"}>
                  <img src={copy} alt="" className="pointer" onClick={copytext} />
                 </Box>   
                 <img src={logoutImg} alt="" className="pointer" onClick={handleDisconnect}/>  
               </Box>             
            </Box>

          <Box  
            display="flex"
            justifyContent="space-between"
            width="100%"
            borderTop={"1px solid rgba(17, 48, 45, 0.08)"}
                
          >
          
            <Box 
            display="flex" 
            flexDirection="column" 
            borderRight="1px solid rgba(17, 48, 45, 0.08)" 
            justifyContent={"center"} 
            alignItems="center">
              {" "}
              {/**flex box item */}
              <Typography variant="body1" color="secondary" className={classes.walletDetailsPopoverValue}>
                {(balance && balance.formatted) ? formatDecimalNumber(balance.formatted): 'NA'} <span style={{fontSize:"0.625rem", color:"rgba(107, 130, 153, 0.8)"}}>{balance?.symbol}</span>
              </Typography>
              <Typography variant="subtitle1" className={classes.walletDetailsPopoverLabel}>
                Balance
              </Typography>
            </Box>
            <Box 
            display="flex" 
            flexDirection="column" 
            borderRight="1px solid rgba(17, 48, 45, 0.08)" 
            justifyContent={"center"} 
            alignItems="center">
              {" "}
              {/**flex box item */}
              <Typography variant="body1" color="secondary" className={classes.walletDetailsPopoverValue}>
                {ChainName(chain?.id)}
              </Typography>
              <Typography variant="subtitle1" className={classes.walletDetailsPopoverLabel}>
                Network
              </Typography>
            </Box>
          </Box>
          
        </Box>
      </Popover>
    </>
  );
};
export default ProjectPopover;
